<template>
  <div class="banner-section-two">
    <div class="container position-relative">
      <img src="@/assets/img/banner/star-01.png" alt="img" class="img-fluid star-01" />
      <img src="@/assets/img/banner/star-02.png" alt="img" class="img-fluid star-02" />
      <img src="@/assets/img/banner/star-03.png" alt="img" class="img-fluid star-03" />
      <img src="@/assets/img/banner/star-04.png" alt="img" class="img-fluid star-04" />
      <img src="@/assets/img/banner/star-05.png" alt="img" class="img-fluid star-05" />
      <img
        src="@/assets/img/icons/banner-book.svg"
        alt="img"
        class="img-fluid star-06 d-none d-xl-flex"
      />
      <img
        src="@/assets/img/icons/banner-icon-03.svg"
        alt="img"
        class="img-fluid star-07 d-none d-xl-flex"
      />
      <img
        src="@/assets/img/icons/banner-icon-01.svg"
        alt="img"
        class="img-fluid star-08 d-none d-xl-flex"
      />
      <img
        src="@/assets/img/icons/banner-icon-02.svg"
        alt="img"
        class="img-fluid star-09 d-none d-xl-flex"
      />
      <img
        src="@/assets/img/icons/banner-icon-04.svg"
        alt="img"
        class="img-fluid star-10 d-none d-xl-flex"
      />
      <img
        src="@/assets/img/banner/soft-star.png"
        alt="img"
        class="img-fluid star-11 d-none d-xl-flex"
      />
      <div class="row align-items-end">
        <div class="col-lg-6">
          <div class="d-flex align-items-center position-relative banner-content">
            <div class="aos" data-aos="zoom-in">
              <div class="banner-info">
                <span class="d-inline-flex fw-semibold text-uppercase mb-3"
                  >The Leader in Online Learning</span
                >
                <h1 class="mb-4">
                  Engaging & Accessible
                  <span class="position-relative banner-title"
                    >Online
                    <img
                      src="@/assets/img/banner/banner-text-bg.png"
                      alt="img"
                      class="img-fluid position-absolute title-bg"
                  /></span>
                  Courses For All
                </h1>
                <div class="banner-form">
                  <div class="d-sm-flex align-items-center">
                    <div class="dropdown">
                      <a
                        class="btn dropdown-toggle d-flex align-items-center"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="isax isax-book me-2"></i>
                        Category
                      </a>
                      <ul class="dropdown-menu p-2">
                        <li>
                          <a
                            class="dropdown-item d-flex align-items-center p-2"
                            href="javascript:void(0);"
                          >
                            Design
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item d-flex align-items-center p-2"
                            href="javascript:void(0);"
                          >
                            Marketing
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item d-flex align-items-center p-2"
                            href="javascript:void(0);"
                          >
                            Framer Developer
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item d-flex align-items-center p-2"
                            href="javascript:void(0);"
                          >
                            Figma Developer
                          </a>
                        </li>
                      </ul>
                    </div>
                    <span>
                      <input
                        type="text"
                        placeholder="Search Courses, Instructors"
                        class="form-control border-0"
                      />
                    </span>
                  </div>
                  <button class="rounded-pill btn btn-primary btn-xl">Search</button>
                </div>
              </div>
              <div class="d-sm-flex align-items-center">
                <!-- Rating star and content -->
                <div class="ms-sm-3 mt-2 mt-sm-0">
                  <!-- Star -->
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item me-0">
                      <i class="fas fa-star text-warning"></i>
                    </li>
                    <li class="list-inline-item me-0">
                      <i class="fas fa-star text-warning"></i>
                    </li>
                    <li class="list-inline-item me-0">
                      <i class="fas fa-star text-warning"></i>
                    </li>
                    <li class="list-inline-item me-0">
                      <i class="fas fa-star text-warning"></i>
                    </li>
                    <li class="list-inline-item me-0">
                      <i class="fas fa-star-half-alt text-warning"></i>
                    </li>
                    <li class="list-inline-item heading-color fw-bold me-0">4.5 / 5.0</li>
                  </ul>
                  <small>From 500+ reviews</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="banner-img-section">
            <img
              src="@/assets/img/banner/banner-bg-01.png"
              alt="img"
              class="img-fluid banner-bg-01 d-none d-xl-flex aos"
              data-aos="fade-up"
              data-aos-easing="linear"
              data-aos-duration="500"
            />
            <img
              src="@/assets/img/banner/banner-bg-02.png"
              alt="img"
              class="img-fluid banner-bg-02 d-none d-xl-flex aos"
              data-aos="fade-up"
              data-aos-easing="linear"
              data-aos-duration="600"
            />
            <img
              src="@/assets/img/hero/hero-1.png"
              alt="img"
              class="img-fluid banner-bg-03 aos"
              data-aos="fade-up"
              data-aos-easing="linear"
              data-aos-duration="900"
            />
            <div class="enrolled-list-cover aos" data-aos="fade-down">
              <div class="enrolled-list">
                <div class="avatar-list-stacked">
                  <span class="avatar avatar-rounded">
                    <img
                      class="border border-white"
                      src="@/assets/img/user/user-01.jpg"
                      alt="img"
                    />
                  </span>
                  <span class="avatar avatar-rounded">
                    <img
                      class="border border-white"
                      src="@/assets/img/user/user-03.jpg"
                      alt="img"
                    />
                  </span>
                  <span class="avatar avatar-rounded">
                    <img
                      class="border border-white"
                      src="@/assets/img/user/user-07.jpg"
                      alt="img"
                    />
                  </span>
                  <span class="avatar avatar-rounded">
                    <img
                      class="border border-white"
                      src="@/assets/img/user/user-08.jpg"
                      alt="img"
                    />
                  </span>
                  <span class="avatar avatar-rounded">
                    <img src="@/assets/img/user/user-06.jpg" alt="img" />
                  </span>
                </div>
                <p class="mb-0">
                  <span class="text-secondary">35K+</span> Students Enrolled
                </p>
              </div>
            </div>
            <div
              class="course-count d-inline-flex align-items-center aos"
              data-aos="fade-down"
            >
              <span class="counter-icon"><i class="ti ti-list-details"></i></span>
              <div>
                <h4 class="text-white">50+</h4>
                <p class="text-light mb-0">Courses</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
